module.exports = __webpack_public_path__ + "img/finance-swiper-2.7ec64d45.png";